import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//*MUI
import { Box, Divider, Tooltip } from '@mui/material';

//*redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../Redux Store/actions';

//*files
import cssClasses from './EventInventory.module.css';
import DropDown from '../../../../Subcomponents/DropDown';
import SearchBar from '../../../../Subcomponents/Search';
import Datagrid from '../../../../Subcomponents/Datagrid';
import ProjectIcon from '../../../../Assets/Images/Sustenance/ProjectIcon.svg';
import {
  getEventByEventName,
  getLaunches,
  getPreSelectLaunches,
} from '../../../../Services/Event';
import LaunchesIcon from '../../../../Assets/Images/Common/noProjectFound.svg';
import { debounce } from 'lodash';
import { DataGrid } from '@mui/x-data-grid';
import Button from '../../../../Subcomponents/Button';
import { toast } from 'react-toastify';
import DownloadExcelModal from '../../../../Modals/EventToken/DownloadExcelModal';

const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },

  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};

function EventInventory() {
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const { eventID } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [Launches, setLaunches] = useState([]);
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState('Latest First');
  const [NoLaunchesFound, setNoLaunchesFound] = useState(null);
  const [EventName, setEventName] = useState('');
  const [search, setSearch] = useState('');
  const [PreSelectTokens, setPreSelectTokens] = useState([]);
  const [NoPreSelectTokens, setNoPreSelectTokens] = useState([]);
  const [PreSelectKey, setPreSelectKey] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    dispatch(action.activeMenu('eventinventory'));
    getEventName();
    getAllLaunchesFromServer(0, false, search, drpDownSelectedVal);
  }, []);

  function getAllLaunchesFromServer(
    pageNumber,
    merge,
    search,
    drpDownSelectedVal
  ) {
    setLaunches([]);
    // let preSelectRoute1 = sessionStorage.getItem("GlobalLeadPreSelected");
    // if(preSelectRoute1 === 'true') {
    //   console.log("preSelectRoute1" , preSelectRoute1)
    //   let Info = JSON.parse(sessionStorage.getItem('GlobalLeadPreSelectedLeadData'));
    //    console.log("INFO" , Info)
    //    if(Info?.selectedEventToken?.tokenId?.isPreselect === true) {
    //     setPreSelectKey(true)
    //     console.log("Info?.selectedEventToken?.tokenId?.tokenId" ,Info?.selectedEventToken?.eventTokenId)
    //     getPreSelectLaunches(Info?.selectedEventToken?.eventTokenId).then((response88) => {
    //       console.log("getPreSelectLaunches" , response88)
    //       if(response88.data.length > 0) {
    //         setNoLaunchesFound(true);
    //       } else {
    //         setNoLaunchesFound(false);
    //       }
    //       response88 = response88.data.map((el , index) => ({
    //         ...el,
    //         id:el.launchid,
    //         index: index,
    //         title:el.title,
    //         Time:el.created_at,
    //       }))

    //       if(merge) {
    //         setLaunches((pre) => [...pre,...response88]);
    //       } else {
    //         setLaunches(response88)
    //       }
    //     }).catch((err) => {
    //       console.log("getPreSelectLaunches" , err)
    //     })
    //    }
    // } else {
    //   setPreSelectKey(false)
    getLaunches(
      eventID,
      search,
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1,
      drpDownSelectedVal
    )
      .then((resp) => {
        console.log('All-Launches', resp);
        const assignedLaunches = resp.data.filter((launch) => {
          return launch.LaunchSalesRelations.length > 0;
        });
        console.log('assignedLaunches: ', assignedLaunches);
        if (assignedLaunches.length > 0) {
          setNoLaunchesFound(true);
        } else {
          setNoLaunchesFound(false);
        }

        const launchesArr = assignedLaunches.map((el, index) => ({
          ...el,
          id: el.launchId,
          index: index,
          title: el.title,
          Time: el.created_at,
        }));
        setLaunches(launchesArr);
      })
      .catch((err) => {
        console.error(err);
      });
  }



  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getAllLaunchesFromServer(passPageNumber, true, search, drpDownSelectedVal);
  }

  function goToProject(projectId, launchId) {
    console.log('project-Name', projectId);
    navigate(
      `/home/Event/Details/${eventID}/Inventory/${launchId}/${projectId}`
    );
  }

  function getEventName() {
    getEventByEventName(eventID)
      .then((response) => {
        console.log('Event-Name', response);
        setEventName(response);
      })
      .catch((err) => {
        console.error('Event-Name', err);
      });
  }

  const debouncedFetchSearchData = debounce((e) => {
    setSearch(e.target.value);
    getAllLaunchesFromServer(
      pageNumber,
      false,
      e.target.value,
      drpDownSelectedVal
    );
  }, 800);

  const ProjectColumns = [
    {
      field: 'title',
      headerName: 'Launch name',
      width: 530,
      renderCell: (params) => {
        return (
          <Box
            className={cssClasses.SubContainer}
            onClick={() =>
              goToProject(params.row.Projects.projectId, params.row.launchId)
            }
            style={{ cursor: 'pointer' }}
          >
            <img src={ProjectIcon} alt={''} />
            <Box className={cssClasses.innerTitle}>{params.row.title}</Box>
          </Box>
        );
      },
    },
    {
      field: 'Time',
      headerName: 'Time',
      width: 500,
      renderCell: (params) => {
        return (
          <Box>
            {new Date(params.row.created_at).toDateString()},{' '}
            {new Date(params.row.created_at).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </Box>
        );
      },
    },
  ];


  const handleDownloadExcel = async () => {
    const res = await fetch(`${process.env.REACT_APP_PAYMENT_LINK_URL}downloadExcel/downloadEventToken`, {
      method: "POST",
      body: JSON.stringify({ eventID: eventID }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser?.accessToken}`,
      },
    });


    // console.log("response for excel download" , res)
    if (!res.ok) {
      toast.error("Failed to download Excel");
      return;
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Event_${EventName[0]?.title}_Launches.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    toast.success("Excel Downloaded Successfully");
  };






  return (
    <Box className={cssClasses.Container}>
      <Box mb={1}>
        <Box className={cssClasses.SubContainer}>
          <Box className={cssClasses.DivContainer} width={'100%'}>
            <Box className={cssClasses.HeaderTitle}>{EventName[0]?.title} </Box>
            <Tooltip title={<h1>{EventName[0]?.description}</h1>}>
              <Box
                className={cssClasses.SubTitle}
                width={'70%'}
                overflow={'hidden'}
                textOverflow={'ellipsis'}
                whiteSpace={'nowrap'}
              >
                {EventName[0]?.description}
              </Box>
            </Tooltip>
          </Box>
        </Box>
      </Box>

      <Divider />

      <Box margin={'1rem 0'}>
        <Box className={cssClasses.ProjectTitle} style={{ display: 'flex', justifyContent: "space-between" }}>
          {Launches.length > 1 ? (
            <Box component={'span'}>{Launches.length} Launches</Box>
          ) : (
            <Box component={'span'}>{Launches.length} Launch</Box>
          )}
          <Button
            btnName={"Download Excel"}
            clicked={async () => {

              setOpenModal(true)
            }}
            style={{
              width: "15%",
              color: "#fff",
              backgroundColor: "rgb(21, 112, 239)",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Inter-Medium !important",
            }}
          />
        </Box>
        {/* give Download Button For Donloading Excel */}
        {/* <Box> */}

        {/* </Box> */}

        <Box margin={'1rem 0'}>
          <Box className={cssClasses.SubTitle}>Sort by</Box>
          <Box className={cssClasses.SubContainer} marginTop={'0.4rem'}>
            <Box width={'25rem'}>
              <DropDown
                list={[
                  'Name Ascending',
                  'Name Descending',
                  'Latest First',
                  'Oldest First',
                ]}
                style={{
                  selectedColor: '#175CD3',
                  background: '#E8F0FE',
                }}
                selectedValue={drpDownSelectedVal}
                onChangeSelect={(_value) => {
                  setDrpDownSelectedVal(_value);
                  getAllLaunchesFromServer(0, false, search, _value);
                }}
              />
            </Box>
            <Box marginLeft={'auto'}>
              <SearchBar
                id={'StudentSearch'}
                value={search}
                placeholder={'Search by Launch name'}
                search={debouncedFetchSearchData}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {Launches?.length > 0 && (
        <Box className={cssClasses.GridWrapper}>
          <DataGrid
            rows={Launches}
            columns={ProjectColumns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            page={pageMaintain}
            onPageChange={(_page) => {
              console.log(_page);
              setPageMaintain(_page);
              if (pageNumber < _page) {
                getMoreData(_page);
              }
            }}
            sx={[dataGridStyles]}
          />
        </Box>
      )}

      {NoLaunchesFound === false && (
        <Box>
          <Box className={cssClasses.noDataMsg}>
            <Box className={cssClasses.emptyIcon}>
              <img src={LaunchesIcon} alt='No Launches Available' />
            </Box>
            <Box className={cssClasses.emptyTitle}>No Launches were Found</Box>
          </Box>
        </Box>
      )}
      <DownloadExcelModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        eventID={eventID}
        EventName={EventName}
        loggedInUser={loggedInUser}
      />
    </Box>

  );
}

export default EventInventory;
